module.exports = __webpack_public_path__ + "dashboard/img/share.fc77e5352ea62dccfbaf6942b75460dd.svg";